import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import { launchdeckLogin } from '../actions/auth-actions';
import { Box, Flex } from '@chakra-ui/react';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import { connect } from 'react-redux';
import ValidationWarningBanner from '../../global/components/helper-components/components/ValidationWarningBanner';
import PageLoader from '../../global/components/helper-components/components/PageLoader';
import { redirectToHomepageIfLoggedIn } from '../helpers/auth-redirect';
import LaunchdeckFormInput from '../../forms/TextInputField/components/LaunchdeckFormInput';
import { validateEmail } from '../../global/helpers/global-helpers';
import { useLocation } from 'react-router-dom';


function LoginForm({ 
	prepopEmail,
	disableEmailField, 
	launchdeckLogin, 
	loginFeedback 
}) {

	const location = useLocation();

	const [loginProcessInProgress, setLoginProcessInProgress] = useState(false)
	const [emailInput, setEmailInput] = useState("")
	const [passwordInput, setPasswordInput] = useState("")

	const [showEmailError, setShowEmailError] = useState(false)
	const [emailErrorMessage, setEmailErrorMessage] = useState("")

	const [showPasswordError, setShowPasswordError] = useState(false)
	const [passwordErrorMessage, setPasswordErrorMessage] = useState("")

	// Feedback output
	const [errorMessageDisplay, setErrorMessageDisplay] = useState("")
	const [displayLoginError, setDisplayLoginError] = useState(false)

	useEffect(() => {
		if (prepopEmail) {
			setEmailInput(prepopEmail)
		}
	}, [prepopEmail]);

	useEffect(()=> {
		if (location.state) {
			const {prepopEmail} = location.state || {}
			setEmailInput(prepopEmail)
		}
	},[location.state])


	useEffect(() => {
		if (loginFeedback) {

			const { results, loading } = loginFeedback || {};
			setLoginProcessInProgress(loading === true ? true : false)

			const { data: logingErrorFeedback } = results || {};
			const { isLoginError, errorPayload } = logingErrorFeedback || {};

			if (isLoginError === true) {
				setDisplayLoginError(true)
				setErrorMessageDisplay(errorPayload.errorMessage ? errorPayload.errorMessage : "There was an unexpected error. Please try again later.")
			} else {
				redirectToHomepageIfLoggedIn()
			}

		}
	}, [loginFeedback]);

	const onPressEnterAndLogin = (e) => {
		if (e.key === 'Enter') {
			handleSubmit();
		}
	}

	const handleChange = (event) => {

		if (event.target.name === "emailInput") {
			setEmailInput(event.target.value)
			setShowEmailError(false)
		} else if (event.target.name === "passwordInput") {
			setPasswordInput(event.target.value)
			setShowPasswordError(false)
		}
	}

	const handleSubmit = () => {
		let trimmedEmail = emailInput ? emailInput.trim() : "";
		const isValidEmail = validateEmail(trimmedEmail);
		let failValidation = "";

		if (!trimmedEmail) {
			setShowEmailError(true)
			setEmailErrorMessage('Email Required')
			failValidation = true;

		} else if (!isValidEmail) {
			setShowEmailError(true)
			setEmailErrorMessage('Invalid email address')
			failValidation = true;
		}

		if (!passwordInput) {
			setShowPasswordError(true)
			setPasswordErrorMessage('Password Required')
			failValidation = true;

		} else if (passwordInput.length < 6) {
			setShowPasswordError(true)
			setPasswordErrorMessage('Please provide a valid password')
			failValidation = true;
		}

		if (trimmedEmail && passwordInput && !failValidation) {
			launchdeckLogin(trimmedEmail, passwordInput)
		}

	}

	if (loginProcessInProgress) {
		return (
			<Box px='1.5em'>
				<PageLoader />
			</Box>
		)
	}

	return (
		<Box px={['0em', '1.5em']}>
			<Box mb='0.5em' w='100%' mt='3%' onKeyDown={(e) => onPressEnterAndLogin(e)}>
				<Box className="authentication-form__container">
					<Flex pt='1em' direction='column' align='center' w='100%' gap='0.5em' maxW={['100%','30em']}>
						<LaunchdeckFormInput
							label='Email'
							name={'emailInput'}
							onChange={handleChange}
							value={prepopEmail || emailInput}

							isDisabled={disableEmailField || false}
							errorLogic={showEmailError}
							errorMessage={emailErrorMessage}
						/>
						<LaunchdeckFormInput
							label='Password'
							name={'passwordInput'}
							onChange={handleChange}
							value={passwordInput}
							type='password'

							errorLogic={showPasswordError}
							errorMessage={passwordErrorMessage}
						/>

						<Flex justify='flex-end' color='gray.500' fontSize='0.7em' w='100%'>
							<Link to="/reset-password">Forgot Password?</Link>
						</Flex>

					</Flex>
				</Box>
			</Box>

			{displayLoginError && <Box p='2em 0em'><ValidationWarningBanner>{errorMessageDisplay}</ValidationWarningBanner></Box>}

			<Flex direction='column' justify='center' alignItems='center' my='2em'>
				<Flex justify={['center', 'flex-end']} w='100%'>
					<LaunchdeckButton bg='brand.500' color='white' w={["100%", "auto"]} onClick={handleSubmit} label='Login' />
				</Flex>
			</Flex>
		</Box>
	);
};


function mapStateToProps(state) {
	return {
		loginFeedback: state.auth.data.login
	};
}


const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			launchdeckLogin
		},
		dispatch,
	)


export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);